import { createSelector } from "reselect";
import { adminSectionSelector } from "../admin_section_selector";

export const monitorAtHomeStatusFilterSelector = createSelector(
  adminSectionSelector,
  adminSection => {
    return adminSection.monitorAtHomeStatusFilter;
  }
);
